/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Payment_Status_PaidInputs */

const vi_expense_payment_status_paid = /** @type {(inputs: Expense_Payment_Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thanh toán`)
};

/**

* @param {Expense_Payment_Status_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_payment_status_paid = /** @type {((inputs?: Expense_Payment_Status_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Payment_Status_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_payment_status_paid(inputs)
});